import Alerts from './alerts';

export default Alerts;
